import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.css'],
    standalone: false
})
export class UploadFileComponent {

  fileToUpload: File;
  @ViewChild("fileinput") fileinput: ElementRef;

  constructor(
      public dialogRef: MatDialogRef<UploadFileComponent>
  ) {
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  openFileInput() {
    this.fileinput.nativeElement.click();
  }

  closeDialog(uploadFile: boolean) {
    this.dialogRef.close(uploadFile ? this.fileToUpload : null);
  }
}
